import { CCol, CForm, CFormSelect, CLoadingButton, CMultiSelect } from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import PlayerService from 'src/service/PlayerService'
import ToastComponent from 'src/components/common/TaostComponent'
import CommonService from 'src/service/CommonService'

const OverseasPlayerBulkUpdate = (props) => {
  const [multiOption, setMultiOption] = useState([])
  const [selectedPlayers, setSelectedPlayers] = useState([])
  const [externalType, setExternalType] = useState(0)
  const [loader, setLoader] = useState(false)

  const externalPlayerTag = props.externalPlayerTag

  useEffect(() => {
    CommonService.clubPlayers().then((result) => {
      setMultiOption(result.data)
    })
  }, [])

  const applyBulkExternalTag = () => {
    if (!externalType || selectedPlayers.length === 0) {
      ToastComponent('Please select players and action', 'error')
      return
    }

    setLoader(true)

    PlayerService.updateExternalPlayers({
      player_ids: selectedPlayers,
      type: Number(externalType),
    }).then((res) => {
      ToastComponent(res.message, 'success')
      setSelectedPlayers([])
      setExternalType('')
      props.setRefreshKey((prev) => prev + 1)
      setLoader(false)
    })
  }

  const getTagNameById = (id, list) => {
    const tag = list?.find((item) => item.id === Number(id))
    return tag ? tag.name : 'External'
  }
  return (
    <>
      <CForm className="row g-3">
        {/* Player Multi Select */}
        <CCol md={5}>
          <CMultiSelect
            options={multiOption}
            selectionType="tags"
            placeholder="Select Players"
            onChange={(selectedOptions) =>
              setSelectedPlayers(selectedOptions.map((option) => option.value))
            }
          />
        </CCol>

        {/* External Player Type */}
        <CCol md={3}>
          <CFormSelect
            value={externalType}
            onChange={(e) => setExternalType(Number(e.target.value))}
          >
            <option value={0}>None</option>

            {externalPlayerTag && (
              <option value={externalPlayerTag}>
                {getTagNameById(externalPlayerTag, props.externalPlayerList)}
              </option>
            )}
          </CFormSelect>
        </CCol>

        {/* Submit */}
        <CCol md={2}>
          <CLoadingButton
            color="success"
            variant="outline"
            loading={loader}
            onClick={applyBulkExternalTag}
          >
            Submit
          </CLoadingButton>
        </CCol>
      </CForm>
    </>
  )
}

export default OverseasPlayerBulkUpdate
